<span class="table__type" [ngClass]="cssClass">
  @if (isWhatsapp) {
    <img src="../../../../../assets/images/common/icon-whatsapp.svg" alt="Whatsapp" />
  } @else {
    <mat-icon>{{ icon }}</mat-icon>
  }
  {{ label }}
</span>